import _ from "lodash"
import PropTypes from "prop-types"

function TypeRadio(props) {
  const matchingOption = _.find(props.options, { value: `${props.value}` })
  const displayValue = matchingOption ? matchingOption.label : props.value

  let newValue = ""
  if (!_.isEmpty(props.description)) {
    newValue = "<strong>" + props.description + "</strong><br>" + displayValue
  } else {
    newValue = displayValue
  }
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: newValue,
      }}
    />
  )
}

TypeRadio.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  description: PropTypes.string,
}
export default TypeRadio
